(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Settings.Agency.User.Commissions",
                {
                    url: "/Commissions",
                    component: "commissions",
                    resolve: {
                    },
                    data: {
                        pageTitle: "Commissions"
                    }
                });
        }
    ]);

    app.component("commissions",
        {
            templateUrl: "/App/Settings/Agency/User/Commissions/commissions-template.html",
            controller: "commissionsController",
            bindings: {
                user: "<"
            }
        });

    commissionsController.$inject = [];
    function commissionsController() {
        var $ctrl = this;

        ng.extend($ctrl,
            {
            });
    }

})(window.app, window.angular); //jshint ignore:line